import {reisy, node, rule, multidecl, decl} from 'reisy';
import {fontDef, KENT_FONTS} from './fonts.js';
import {scrollbarSize} from '../environment.js';
import './globals.js';
import './typography.js';

export default function initStyle(options) {
	const {
		styles = [], styleOverrides = [], fonts = {},
		branding, showTime, yeOldeKosk, jackInTheBox,
	} = options;
	let overrides = [
		node('Settings', 'Branding', [], decl(branding !== false)),
		node('Settings', 'YeOldeKosk', [], decl(yeOldeKosk)),
		node('Settings', 'JackInTheBox', [], decl(Boolean(jackInTheBox))),
		node('Settings', 'JackInTheBoxContainReader', [], decl(jackInTheBox && jackInTheBox.containReader !== false)),
		node('Settings', 'ShowTime', [], decl(showTime)),
		node('Environment', 'ScrollbarSize', [], decl(scrollbarSize)),
	];

	Object.keys(fonts).forEach(name => overrides.push(fontDef(~KENT_FONTS.indexOf(name) ? `${name}-override` : name, fonts[name])));

	if (Array.isArray(styles)) {
		overrides = overrides.concat(styles);
	}

	overrides = overrides.concat(styleOverrides);

	reisy.overrides(overrides);
}



// WEBPACK FOOTER //
// ./lib/styling/index.js